export default __webpack_public_path__ + "static/media/Start creating a basic Journal.a284581a.mp4";